import React from 'react';
import LikeSVG from '@catalogo/ui-americanas-desktop-svg/like-v2.svg';
import withFeedback from '@catalogo/service-americanas-product/src/questions-and-answers/hoc/feedback';
import { Wrapper, TextMobile, TextDesk, LikeAndDislike, WrapperButton, Like, Count, Dislike } from './styled';
import { IFeedback } from '../../../types';

export const Feedback = ({ feedback, handleClick, isDesk }: IFeedback) => {
  const textDevice = isDesk ? (
    <TextDesk>a resposta foi útil?</TextDesk>
  ) : (
    <TextMobile>
      a resposta foi <br /> útil?
    </TextMobile>
  );

  return (
    <Wrapper isDesk={isDesk}>
      {textDevice}
      <LikeAndDislike isDesk={isDesk}>
        <WrapperButton onClick={() => handleClick('like', feedback.like)}>
          <Like $feedback={feedback.like}>
            <LikeSVG />
          </Like>
          <Count isDesk={isDesk}>({feedback.likeCount})</Count>
        </WrapperButton>
        <WrapperButton onClick={() => handleClick('dislike', feedback.dislike)}>
          <Dislike $feedback={feedback.dislike}>
            <LikeSVG />
          </Dislike>
          <Count isDesk={isDesk}>({feedback.dislikeCount})</Count>
        </WrapperButton>
      </LikeAndDislike>
    </Wrapper>
  );
};

export default withFeedback(Feedback);
